import React from "react"
import game from "mini-bridge.png"

const MiniBridge = props => <img src={game} className="game" {...props} />

export default MiniBridge
